<div class="header-container" *ngIf="showHeader">
    <mat-toolbar class="header" [ngStyle]="styleReturnWithTheme('header')">
        <div class="left-side">
            @if (appService.selectedTheme) {
                <img class='header-logo dhl-logo' style="cursor: pointer;" (click)="router.navigateByUrl('/home')" src='../../../../assets/images/dhl_logo.png' />
                <img class='header-logo ford-logo' style="cursor: pointer;" (click)="router.navigateByUrl('/home')" src='../../../../assets/images/ford_logo.png' />
            }
            @else{
                <img class='header-logo ford-logo' style="cursor: pointer;left:5vw" (click)="router.navigateByUrl('/home')" src='../../../../assets/images/ford_logo.png' />
                <img class='header-logo dhl-logo' style="cursor: pointer;left: 10vw;" (click)="router.navigateByUrl('/home')" src='../../../../assets/images/dhl_footer.png' />
            }

        </div>
        <div class="right-side" *ngIf="!(this.router.url).includes('page-not-found')" >
            <!-- <div class="help icon-list" (click)="onHelpIcon()">
                <mat-icon style="top: 2px; position: relative;">help</mat-icon> <span>Help</span>
            </div> -->
            <div class="maintenance icon-list" (click)="onMaintenace()">
                <mat-icon>engineering</mat-icon> <span>Maintenance</span> 
            </div>
            <div class="profile-info icon-list" (click)="onProfileDropDown()">
                <mat-icon >person</mat-icon>
                <span class="user-name" *ngIf="appService.userData?.FirstName">{{userData?.FirstName? (userData?.FirstName + " " + userData?.LastName ):"Admin" }}</span>
                <mat-icon style="transform: rotate(90deg); font-size: 16px;">chevron_right</mat-icon>
            </div>
        </div>
    </mat-toolbar>
    <mat-toolbar class="sub-header" [ngStyle]="styleReturnWithTheme('sub')" *ngIf="!(this.router.url).includes('page-not-found')">
        <div class="left-side" >

            <div class="subnav">
                <div class="sub-menu" [ngStyle]="{'color':appService.selectedTheme?'#000':'#fff'}" [ngClass]="{ 'active': selectedMenu === 'rate-agreement' }" (click)="onMenuSelection('rate-agreement')">Rate Agreement</div>
                <div class="sub-menu" [ngStyle]="{'color':appService.selectedTheme?'#000':'#fff'}" [ngClass]="{ 'active': selectedMenu === 'fuel-escalator' }" (click)="onMenuSelection('fuel-escalator')">Fuel Escalator</div>
                <div class="sub-menu" [ngStyle]="{'color':appService.selectedTheme?'#000':'#fff'}" [ngClass]="{ 'active': selectedMenu === 'bidpack' }" (click)="onMenuSelection('bidpack')">Bid Pack</div>
                <div class="sub-menu" [ngStyle]="{'color':appService.selectedTheme?'#000':'#fff'}" [ngClass]="{ 'active': selectedMenu === 'carrier' }" (click)="onMenuSelection('carrier')">Carrier</div>
                <div class="sub-menu" [ngStyle]="{'color':appService.selectedTheme?'#000':'#fff'}" [ngClass]="{ 'active': selectedMenu === 'contact' }" (click)="onMenuSelection('contact')">Contact</div>
            </div>
        </div>
    </mat-toolbar>
    <div class="profile-details" *ngIf="selectUser">
        <div style="font-weight: 600;">{{userData?.FirstName + " " + userData?.LastName}}</div>
        <div style="padding: 10px;">{{userData?.RoleName}}</div>
        <div style="color: #D40511;cursor: pointer;" (click)="onLogout()" >Logout</div>
    </div>
</div>